import styles from './CreationSuccessOverlay.module.css'

export function CreationSuccessOverlay() {
  return (
    <div
      className={styles.overlay}
      role="status"
      aria-live="polite"
      aria-label="Criando liga"
    >
      <div className={styles.inner}>
        <div className={styles.iconWrap} aria-hidden="true">
          <svg width="72" height="72" viewBox="0 0 72 72" fill="none">
            <circle cx="36" cy="36" r="36" fill="rgba(0, 229, 195, 0.08)" />
            <circle
              cx="36"
              cy="36"
              r="28"
              stroke="var(--accent)"
              strokeWidth="1.5"
              fill="none"
              strokeDasharray="4 4"
              opacity="0.4"
            />
            <circle
              cx="36"
              cy="36"
              r="22"
              stroke="var(--accent)"
              strokeWidth="2"
              fill="none"
            />
            <path
              d="M24 36.5L31.5 44L48 28"
              stroke="var(--accent)"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <p className={styles.text}>Criando sua liga…</p>
      </div>
    </div>
  )
}
